import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UserPage } from '../user/user';

/**
 * Generated class for the ChatInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-chat-info',
  templateUrl: 'chat-info.html',
})
export class ChatInfoPage {
  users_keys: any = [];
  users: any = [];
  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.users = this.navParams.get('users');
    this.users_keys = Object.keys(this.users);
    // console.log("this.users", this.users);
    // console.log("this.users_keys", this.users_keys);
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad ChatInfoPage');
    // console.log("this.users", this.users);
    // console.log("this.users_keys", this.users_keys);
  }


  goToUser(user){
    console.log("goToUser", user);
    this.navCtrl.push(UserPage, {user : user})
  }

}



// WEBPACK FOOTER //
// ./src/pages/chat-info/chat-info.ts